import React from "react";
import CheckMark from "~/images/checkmark.svg";
import ErrorIcon from "~/images/crosswhite.svg";

const CustomToast = ({ type = "success", message }) => {
  const icon = type === "error" ? ErrorIcon : CheckMark;
  return (
    <div className="flex flex-row gap-3  rounded-md">
      <img src={icon} className="h-5 w-5" alt="" />
      <div>
        <p className="font-semibold leading-5 mb-1">{type.charAt(0).toUpperCase() + type.slice(1)}!</p>
        <p className="text-sm">{message}</p>
      </div>
    </div>
  );
};
export default CustomToast;
